<template>
  <el-dialog title="冷库能流图" :visible.sync="sankeVisible" width="1280px" height="520px" :before-close="handleClose" :close-on-click-modal="false" backgroud="white" center>
    <div class="chart-item">
      <div class="chart-header">
        <div class="chart-header">冷库能流图</div>
        <div class="chart-filter">
          <el-date-picker v-model="ruleForm.startDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="开始日期" @change="freezerEnergyMeter"/>
          ~
          <el-date-picker v-model="ruleForm.endDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="截止日期" @change="freezerEnergyMeter"/>
        </div>
      </div>
      <ECharts :options="energyOption" class="chart"/>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ECharts from '@/components/view/ECharts.vue';
import { DateToShort } from "@/utils/util/util";
export default {
  data() {
    return {
      ruleForm: {
         project: null,
         startDate: '2025-11-01',
         endDate: '2025-11-15',
      },
      energyOptionData: {
        "data": [],
        "links": [],
      },
      energyOption: {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            nodeAlign: "left",
            data: [],
            links: [],
            lineStyle: {
              color: "source",
              curveness: 0.5,
            },
            itemStyle: {
                borderWidth: 0.5,
                borderColor: '#ffffff'
            },
            label: {
                show: true, 
                color: 'lightGray',
                fontSize: 13,
                formatter: function(params) {
                  var label=params.name+'\r\n'+params.value+" kW·h";
                  return label;
                }
            },
            emphasis: {
                focus: 'adjacency'
            }
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["sankeVisible","project"],
  watch: {
    sankeVisible(newValue) {
      if (newValue) {
        this.ruleForm.project=this.project;
        const currentDate = new Date();
        const fifteenDaysAgo = new Date();
        fifteenDaysAgo.setDate(currentDate.getDate() - 30);
        this.ruleForm.startDate=DateToShort(fifteenDaysAgo);
        this.ruleForm.endDate=DateToShort(currentDate);
        this.initEnergyOption();
        this.freezerEnergyMeter();
      }
    },
  },
  components: {
    ECharts
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    freezerEnergyMeter() {
      const that=this;
      var params={
          project: that.project,
          dateStart: that.startEnergy,
          dateEnd: that.endEnergy,
      }
      that.request.freezerEnergyMeter(params).then((res) => {
        if (res.code==0) {
          that.energyOptionData = res.data;
          that.initEnergyOption();
          that.$forceUpdate();
        } 
      });
    },
    initEnergyOption() {
      this.energyOption={
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            nodeAlign: "left",
            data: this.energyOptionData.data,
            links: this.energyOptionData.links,
            lineStyle: {
              color: "source",
              curveness: 0.5,
            },
            itemStyle: {
                borderWidth: 0.5,
                borderColor: '#ffffff'
            },
            label: {
                show: true, 
                color: 'lightGray',
                fontSize: 13,
                formatter: function(params) {
                  var label=params.name+'\r\n'+params.value+" kW·h";
                  return label;
                }
            },
            emphasis: {
                focus: 'adjacency'
            }
          },
        ],
      }
    },
  },
};
</script>
<style scoped>
.form-body {
  display:flex;
  flex-direction:row;
  justify-content:center;
  box-sizing:border-box;
}

.chart-item {
  flex: 1 1 calc(50% - 10px);
  background-color: black;
  color: white;
  border-radius: 4px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-top: 5px;
  box-sizing: border-box;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 5px;
}

.chart-date, .chart-filter, .chart-year {
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.chart {
  width: 100%;
  height: 100%;
  background-color: rgba(31, 51, 89, 0);
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 140px;
  text-align: center;
}
</style>